import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { colors } from '../../../../../colorVars';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { useAlertsStore } from '../../../../../stores/websocketStore/_alertsStore';
import { ConnectBrokerageButton } from '../../../../atomic/buttons/connectBrokerageButton/ConnectBrokerageButton';
// import { DocsButton } from '../../../../atomic/buttons/docsButton/DocsButton';
import { LogoutButton } from '../../../../atomic/buttons/logoutButton/LogoutButton';
import { MultiSwitch } from '../../../../atomic/buttons/multiSwitch/MultiSwitch';
// import { TuLinkButton } from '../../../../atomic/buttons/TuLinkButton/TuLinkButton';
import { UserPrefsButton } from '../../../../atomic/buttons/userPrefsButton/UserPrefsButton';
import TULogo from '../../../../atomic/logo/TULogo';
import { AccountBalances } from '../../../navbar/accountBalances/AccountBalances';
import { ApiCallsLeft } from '../../../navbar/apicalls/ApiCallsLeft';
import { NavClock } from '../../../navbar/NavClock';
import { SymbolsLeft } from '../../../navbar/symbolsLeft/SymbolsLeft';
import { AlertsUserPrefsModal } from '../alertsUserPrefsModal/AlertsUserPrefsModal';
import { ConnectBrokerageModal } from '../../../notifications/tradierLoginModal/ConnectBrokerageModal';
import style from './AlertsHeader.module.css';

export const AlertsHeader = observer(() => {
  const { applicationTypeStore, userAuthStore } = useWebsocketStore();
  const { dataSource, setDataSource } = useAlertsStore();
  const [userPreferencesModalOpen, setUserPreferencesModalOpen] =
    useState(false);
  const [connectModalOpen, setConnectModalOpen] = useState(false);
  const applicationType = applicationTypeStore.applicationType ?? null;
  const isSecondaryApplication =
    applicationTypeStore.isSecondaryApplication ?? null;

  const handleLogout = async () => {
    // Logout from JWT auth (calls backend /api/auth/logout and clears localStorage)
    await userAuthStore.logout();

    // Redirect to frontend login page
    window.location.href = '/ui/login';
  };

  return (
    <header className={style.header} style={{ backgroundColor: colors.black }}>
      <AlertsUserPrefsModal
        open={userPreferencesModalOpen}
        handleClose={() => setUserPreferencesModalOpen(false)}
      />
      <div className={style.logo}>
        <TULogo width={180} height={70} />
      </div>
      <div className={style.clockContainer}>
        <div className={style.flexColumn}>
          <NavClock />
          <SymbolsLeft />
          <ApiCallsLeft />
        </div>
      </div>
      <div className={style.buttonArray}>
        {applicationType === 'TRADE_UNAFRAID_TESTING' ? (
          <MultiSwitch
            labels={['Live', 'Sim']}
            values={['LIVE', 'SIMULATED']}
            controlledValue={dataSource}
            setValue={setDataSource}
          />
        ) : null}
        {applicationType === 'TU_ALERTS' ? (
          <UserPrefsButton
            color={colors.lightGrey}
            size={30}
            clickHandler={() => setUserPreferencesModalOpen((prev) => !prev)}
          />
        ) : null}
        <AccountBalances />
        {!isSecondaryApplication ? (
          <ConnectBrokerageButton
            color={colors.lightGrey}
            size={30}
            title="Connect brokerage"
            clickHandler={() => setConnectModalOpen(true)}
          />
        ) : null}
        <ConnectBrokerageModal
          open={connectModalOpen}
          handleClose={() => setConnectModalOpen(false)}
          page="ALERTS"
        />

        {/* <DocsButton
          clickHandler={openDocs}
          size={32}
          color={colors.lightGrey}
        /> */}
        <LogoutButton
          color={colors.red}
          size={30}
          clickHandler={handleLogout}
          title="Logout of Trade Unafraid"
        />
      </div>
    </header>
  );
});
